import { throttle, fitText } from '../../../common/utils';

import els from './elements';

let context = null;

const prepareHeading = () => {

    const $text = els.$headingText();
    const $pole = els.$headingPole();

    $text.shrinkWrap();

    gsap.set($pole, { xPercent: -105 });
    gsap.set($pole, { autoAlpha: 1 });

    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: $text,
            start: 'center 75%',
        },
    });

    timeline.fromTo(
        $text,
        {
            xPercent: -10,
        },
        {
            xPercent: 0,
            autoAlpha: 1,
            ease: 'power2.out',
            duration: 0.75,
        }
    );

    timeline.to(
        $pole,
        {
            xPercent: 0,
            ease: 'power3.out',
            duration: 1,
        },
        '<'
    );
};

const prepareBlocks = () => {

    const $wrap = els.$blocksWrap();
    const $blocks = els.$blocks();
    const $largeBlockLabels = els.$largeBlockLabels();
    const $smallBlockValues = els.$smallBlockValues();

    gsap.set($blocks, { autoAlpha: 0 });
    gsap.set($wrap, { autoAlpha: 1 });

    $largeBlockLabels
        .add($smallBlockValues)
        .each((_, element) => fitText(element));

    $blocks.each((index, element) => {

        const scrollTrigger = {
            trigger: element,
            start: 'top 70%',
        };

        if (index === 0) {

            gsap.fromTo(
                element,
                {
                    xPercent: -25,
                },
                {
                    xPercent: 0,
                    autoAlpha: 1,
                    ease: 'power2.inOut',
                    duration: 0.6,
                    scrollTrigger,
                }
            );

        } else if (index === $blocks.length - 1) {

            gsap.fromTo(
                element,
                {
                    xPercent: 25,
                },
                {
                    xPercent: 0,
                    autoAlpha: 1,
                    ease: 'power2.inOut',
                    duration: 0.9,
                    scrollTrigger,
                }
            );

        } else {

            gsap.fromTo(
                element,
                {
                    yPercent: 25,
                },
                {
                    yPercent: 0,
                    autoAlpha: 1,
                    ease: 'power4.inOut',
                    duration: 0.75,
                    scrollTrigger,
                }
            );
        }
    });
};

const prepareButton = () => {

    const $link = els.$link();

    gsap.fromTo(
        $link,
        {
            yPercent: -100,
        },
        {
            yPercent: 0,
            autoAlpha: 1,
            ease: 'power2.inOut',
            duration: 0.75,
            scrollTrigger: {
                trigger: $link,
                start: 'top 65%',
            },
        }
    );
};

const prepare = () => {

    context = gsap.context(() => {

        prepareHeading();
        prepareBlocks();
        prepareButton();
    });
};

const cleanUp = () => {

    els.$headingText().unshrinkWrap();

    gsap.set(els.$largeBlockLabels, { clearProps: 'fontSize' });

    context?.revert();
};

const initialize = () => {

    prepare();

    $(window).on(
        'resize:horizontally',
        throttle(
            () => {
                cleanUp();
                prepare();
            },
            50
        )
    );
};

export default {
    initialize,
};

